import React, { useState, useEffect, useRef } from 'react';
import './ProfileCard.css';

const ProfileCard = ({ onClick, profileImage }) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  const handleViewProfile = () => {
    setShowMenu(false);
    onClick();
  };

  return (
    <div className="profile-card-container" ref={menuRef}>
      <button className="profile-card" onClick={() => setShowMenu(!showMenu)} type="button" aria-label="Open profile menu">
        <div className="profile-avatar" 
             style={profileImage ? { backgroundImage: `url(${profileImage})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}>
          {!profileImage && <span>👤</span>}
        </div>
        <span className="profile-menu-indicator">⋮</span>
      </button>

      {showMenu && (
        <div className="profile-dropdown-menu">
          <button onClick={handleViewProfile} className="profile-menu-item">
            👤 View Profile
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileCard;
